import React from 'react';
import {View, ScrollView, Alert, Text, Image, TextInput} from 'react-native';
import { connect } from 'react-redux';

import { addContentToUserProgress } from "../../../../redux/actions";

import Colors from "../../../../constants/Colors";
import {ButtonWithSpinner, Card, InformationDialogue, SpinnerControl} from "../../../../components";
import get from "../../../../api/methods/get";
import { CONTENT_GET_SPECIFIC } from "../../api/journeyEndpoints";
import QuizTitleComponent from "../quiz/QuizTitleComponent";
import {stringIsEmpty} from "../../../../constants/StringChecker";
import NavBar from "../../../../components/NavBar";
import queryString from "query-string";

class Enigma extends React.Component {

    state = {
        isFetching: false,
        contentData: null,
        isSending: false,
        answerText: "",

        showSuccessModal: false,
        showErrorModal: false,
        errorMessage: "",
    }

    handleSend = async () => {

        if (stringIsEmpty(this.state.answerText)) {
            this.setState({
                showErrorModal: true,
                errorMessage: "É necessário escrever uma resposta!"
            })
            return;
        }

        if (this.state.isSending) return;
        this.setState({ isSending: true });

        try {
            await this.props.addContentToUserProgress('enigma', this.state.contentData.id, { userAnswer: this.state.answerText });
            this.setState({ showSuccessModal: true })
        } catch (e) {
            this.setState({
                showErrorModal: true,
                erroMessage: "Não conseguimos enviar a sua resposta! Tente novamente mais tarde!"
            })
        }

        this.setState({ isSending: false });

    }

    fetchOriginal = async () => {
        if (this.state.isFetching) return;
        this.setState({ isFetching: true });

        try {
            const values = queryString.parse(this.props.location.search);
            const contentId = values.contentId;
            let result = await get(CONTENT_GET_SPECIFIC("enigma", contentId));
            let json = await result.json();
            console.log(json);
            this.setState({ contentData: json.data });
        } catch (e) {
            console.log(e);
        }

        this.setState({ isFetching: false });
    }

    componentDidMount() {
        this.fetchOriginal();
    }

    render() {

        const isCompleted = this.props.location.state.isCompleted;
        if (isCompleted) {
            return (
                <NavBar title={"Enigma"}>

                    <Text style={{ color: Colors.spinnerNoBackgroundTextColor, textAlign: 'center', fontSize: 18, margin: 20 }}>
                        Você já enviou uma resposta para este enigma!
                    </Text>
                </NavBar>
            )
        }

        return (
            <NavBar title={"Enigma"}>

                <InformationDialogue
                    isModalVisible={this.state.showSuccessModal}
                    titleText={"Sucesso!"}
                    descriptionText={"Sua resposta foi enviada com sucesso!"}
                    onClose={() => this.props.history.goBack()}
                />

                <InformationDialogue
                    isModalVisible={this.state.showErrorModal}
                    titleText={"Erro"}
                    descriptionText={this.state.errorMessage}
                    onClose={() => this.setState({ showErrorModal: false, })}
                />

                <SpinnerControl isFetching={this.state.isFetching} text={"Estamos carregando o conteúdo!"} textPropsStyle={{ color: Colors.spinnerNoBackgroundTextColor }} />

                {
                    this.state.contentData !== null &&
                        <View style={{ width: 400 }}>
                            <QuizTitleComponent title={this.state.contentData.title} />

                            <Card containerStyle={{ margin: 20, backgroundColor: 'white', borderRadius: 0 }}>
                                <Text style={{ fontSize: 16 }}>
                                    { this.state.contentData.description }
                                </Text>
                            </Card>

                            {
                                this.state.contentData.images.map((item, index) => {
                                    return (
                                        <View key={index.toString()} style={{ marginTop: 12, marginBottom: 12 }}>
                                            <Image
                                                source={{ uri: `data:image/jpeg;base64,${item.imageSource}` }}
                                                resizeMode='contain'
                                                style={{ height: 300, width: 400, alignSelf: 'center' }}
                                            />

                                            <Text style={{ textAlign: 'center', fontSize: 14, color: 'white' }}>
                                                { item.subtitle }
                                            </Text>

                                        </View>
                                    )
                                })
                            }

                            <Card containerStyle={{ margin: 20 }}>
                                <Text style={{ fontSize: 18, color: 'white' }}>
                                    Resposta:
                                </Text>
                                <TextInput
                                    style={{ backgroundColor: Colors.cardBackgroundColor, color: 'white', minHeight: 140, maxHeight: 140, padding: 8, borderRadius: 8, textAlignVertical: 'top'}}
                                    value={this.state.answerText}
                                    placeholder={"Escreva sua resposta aqui"}
                                    placeholderTextColor={'white'}
                                    onChangeText={(newValue) => this.setState({ answerText: newValue })}
                                    multiline
                                />

                                <ButtonWithSpinner
                                    isLoading={this.state.isSending}
                                    text={"Enviar"}
                                    onPress={this.handleSend}
                                    containerPropsStyle={{ height: 30, borderRadius: 8 }}
                                    textPropsStyle={{ fontSize: 16 }}
                                />
                            </Card>
                        </View>

                }



            </NavBar>
        )
    }

}

const mapStateToProps = state => {
    return {}
}

export default connect(mapStateToProps, { addContentToUserProgress })(Enigma)
